import Loader from "components/Loader";
import SoftBox from "components/SoftBox";
import { useTranslation } from "react-i18next";

export default function AnalysisModal({ recommendations }) {
  const { t } = useTranslation();
  return (
    <>
      {!recommendations && <Loader />}
      {recommendations && (
        <>
          <SoftBox
            variant="gradient"
            bgColor={"white"}
            borderRadius="md"
            shadow="md"
            p={2}
            mt={2}
          >
            <h3>{t("addToken")}</h3>
            {recommendations.add.map((pair) => {
              return (
                <p style={{ fontSize: "16px" }}>
                  {pair.token}: {pair.reason}
                </p>
              );
            })}
          </SoftBox>
          <SoftBox
            variant="gradient"
            bgColor={"white"}
            borderRadius="md"
            shadow="md"
            p={2}
            mt={2}
          >
            <h3>{t("removeToken")}</h3>
            {recommendations.remove.map((pair) => {
              return (
                <p style={{ fontSize: "16px" }}>
                  {pair.token}: {pair.reason}
                </p>
              );
            })}
          </SoftBox>
          <SoftBox
            variant="gradient"
            bgColor={"white"}
            borderRadius="md"
            shadow="md"
            p={2}
            mt={2}
          >
            <h3>{t("rebalanceToken")}</h3>
            {recommendations.rebalance.map((pair) => {
              return (
                <p style={{ fontSize: "16px" }}>
                  {pair.token}: {pair.reason}
                </p>
              );
            })}
          </SoftBox>
        </>
      )}
    </>
  );
}
